import React, { Component } from 'react'
import { activateAccount, resetUserEmail, appUrls } from '../utils/authService';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import appsArray from '../data/appUrls';

class Activation extends Component {

  componentDidMount() {
      document.title = 'City of Seattle | Activate Account'
  
      function getParameterByName(name, url = window.location.href) {
          name = name.replace(/[\[\]]/g, '\\$&');
          var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }

      var appName = getParameterByName('appName');
      appName = appName.replace(/\//g, '');
      var userName = getParameterByName('userName');  

    const { t, token, showNotification } = this.props;
    activateAccount(token)
      .then(() => {
        sessionStorage.setItem('activated', true);
        showNotification({
          type: 'success',
          title: t('activationSuccessTitle'),
          message: `${t('activationSuccess')} You will be redirected in 3 seconds`
        });
          resetUserEmail(userName).then(() => {
              var redirectUrl;
              appUrls(appName).then((response) => {
                  redirectUrl = response.data.loginUrl;
              });  

              setTimeout(() => { window.location.href = redirectUrl; }, 3000);
          });
               
      }).catch(() => {
          showNotification({
            type: 'failure',
            title: t('activationFailedTitle'),
            message: t('activationFailed'),
            link: window.location.origin + `/#/reactivation`,
            linkText: t('activationFailedLinkText'),
          })
      })
  }

  render() {
    const {
      t
      } = this.props

    return (
        <div className="return-link-post-activation">
          
      </div>
    )
  }
}

export default withTranslation()(Activation);
